const getValueByAccessorString = (
  obj: Record<string, any>,
  accessor: string // this is something like 'a.b.c' or 'a' with a,b,c being keys in a nested object
): any => accessor.split('.').reduce((acc, key) => acc?.[key], obj);

export default getValueByAccessorString;
